import React, { Component } from "react";
import { FaLinkedinIn } from "react-icons/fa";

const SocialShare = [
  //  { Social: <FaFacebookF />, link: "https://www.facebook.com/" },
  {
    Social: <FaLinkedinIn />,
    link: "https://www.linkedin.com/company/dpm-solutions-fr",
  },
  //  { Social: <FaInstagram />, link: "https://www.instagram.com/" },
  //  { Social: <FaTwitter />, link: "https://twitter.com/" },
];

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer-area">
          <div className="footer-wrapper">
            <div className="row align-items-end row--0">
              <div className="col-lg-6">
                <div className="footer-left">
                  <div className="inner">
                    <span>Un Projet ?</span>
                    <h2>Parlons-en !</h2>
                    <a className="rn-button-style--2" href="/contact">
                      <span>Demander une estimation</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="footer-right" data-black-overlay="6">
                  <div className="row">
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="footer-link">
                        <h4>Accès rapide</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="/">Accueil</a>
                          </li>
                          <li>
                            <a href="/legal">Mentions légales</a>
                          </li>
                          <li>
                            <a href="/contact">Contact</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Single Widget  */}
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                      <div className="footer-link">
                        <h4>Contactez-nous</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="mailto:contact@dpm-solutions.fr">
                              contact@dpm-solutions.fr
                            </a>
                          </li>
                          <li>
                            <a href="mailto:paul@dpm-solutions.fr">
                              paul@dpm-solutions.fr
                            </a>
                          </li>
                        </ul>

                        <div className="social-share-inner">
                          <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                            {SocialShare.map((val, i) => (
                              <li key={i}>
                                <a href={`${val.link}`}>{val.Social}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* End Single Widget  */}

                    <div className="col-lg-12">
                      <div className="copyright-text">
                        <p>
                          Copyright © {new Date().getFullYear()} DPM Solutions.
                          Tous droits réservés.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
export default Footer;
